import { Drawer, Loading } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDrawerState } from '../../components';
import {
  useCreateReservedProject,
  useReservedProject,
  useUpdateReservedProject,
} from '../_hooks/reserved-project';
import { ReservedProjectForm } from './ReservedProjectForm';

export const ReservedProjectFormDrawer: FC = () => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const { drawerState, setDrawerState } = useDrawerState();

  const isOpen = drawerState.open && drawerState.type === 'reserved-project';
  const isEdit = isOpen && drawerState.isEditing;

  const { data, isLoading } = useReservedProject(isEdit ? drawerState.id : '');

  const { mutateAsync: createReservedProject } = useCreateReservedProject();
  const { mutateAsync: updateReservedProject } = useUpdateReservedProject();

  return (
    <Drawer
      destroyOnClose
      open={isOpen}
      onClose={() => {
        setDrawerState({ open: false });
      }}
    >
      {isEdit && isLoading ? (
        <Loading />
      ) : (
        <ReservedProjectForm
          initialValues={data}
          onSubmit={async (values) => {
            isEdit
              ? await updateReservedProject({ ...values, id: drawerState.id })
              : await createReservedProject(values);

            await Promise.all([
              isEdit
                ? openMessage('success', t('message-update-completed'))
                : openMessage('success', t('message-create-completed')),
              (async () => {
                setDrawerState({ open: false });
              })(),
            ]);
          }}
        />
      )}
    </Drawer>
  );
};
